/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Intent_RoutingInputs */

const en_svchip_intent_routing = /** @type {(inputs: Svchip_Intent_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intent routing`)
};

const ar_svchip_intent_routing = /** @type {(inputs: Svchip_Intent_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التوجيه حسب النية`)
};

const bn_svchip_intent_routing = /** @type {(inputs: Svchip_Intent_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`উদ্দেশ্য রাউটিং`)
};

const de_svchip_intent_routing = /** @type {(inputs: Svchip_Intent_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absichts-Routing`)
};

const es_svchip_intent_routing = /** @type {(inputs: Svchip_Intent_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enrutamiento por intención`)
};

const fr_svchip_intent_routing = /** @type {(inputs: Svchip_Intent_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routage par intention`)
};

const pt_svchip_intent_routing = /** @type {(inputs: Svchip_Intent_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roteamento por intenção`)
};

const zh_svchip_intent_routing = /** @type {(inputs: Svchip_Intent_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`意图路由`)
};

const tr_svchip_intent_routing = /** @type {(inputs: Svchip_Intent_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niyet yönlendirme`)
};

const ru_svchip_intent_routing = /** @type {(inputs: Svchip_Intent_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маршрутизация по намерению`)
};

const pl_svchip_intent_routing = /** @type {(inputs: Svchip_Intent_RoutingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routing intencji`)
};

/**
* | output |
* | --- |
* | "Intent routing" |
*
* @param {Svchip_Intent_RoutingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_intent_routing = /** @type {((inputs?: Svchip_Intent_RoutingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Intent_RoutingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_intent_routing(inputs)
	if (locale === "bn") return bn_svchip_intent_routing(inputs)
	if (locale === "de") return de_svchip_intent_routing(inputs)
	if (locale === "es") return es_svchip_intent_routing(inputs)
	if (locale === "fr") return fr_svchip_intent_routing(inputs)
	if (locale === "pt") return pt_svchip_intent_routing(inputs)
	if (locale === "zh") return zh_svchip_intent_routing(inputs)
	if (locale === "tr") return tr_svchip_intent_routing(inputs)
	if (locale === "ru") return ru_svchip_intent_routing(inputs)
	if (locale === "pl") return pl_svchip_intent_routing(inputs)
	return en_svchip_intent_routing(inputs)
});